import { render } from "./FacturaForm.vue?vue&type=template&id=19afb93c&scoped=true"
import script from "./FacturaForm.vue?vue&type=script&lang=js"
export * from "./FacturaForm.vue?vue&type=script&lang=js"

import "./FacturaForm.vue?vue&type=style&index=0&id=19afb93c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19afb93c"

export default script